import type { VirtualAppointmentStatus } from '../../services/virtualAppointments';

// Mirrors the cancel route: any pending VA, whatever the patient's workflow step; done and canceled are final.
const CANCELABLE_STATUSES: ReadonlySet<VirtualAppointmentStatus> =
    new Set<VirtualAppointmentStatus>(['planned', 'open', 'waiting_patient', 'waiting_doctor']);

export function canCancelVirtualAppointment(status: VirtualAppointmentStatus): boolean {
    return CANCELABLE_STATUSES.has(status);
}
